//Utility and Framework Functions
let debug_enabled = true;

let debug = (message = "null", level = "debug") => {
  if (debug_enabled && console && console.log) {
    switch (level) {
      case "warn":
        {
          console.warn(message);
          break;
        }
      case "error":
        {
          console.error(message);
          break;
        }
      case "info":
        {
          console.info(message);
          break;
        }
      case "table":
        {
          if (console.table) {
            console.table(message);
          } else {
            console.log(message);
          }
          break;
        }
      case "dump":
        {
          if (console.dir) {
            console.dir(message);
          } else {
            console.log(message);
          }
          break;
        }
      default:
        {
          // if(typeof message == 'object') {
          //   let to_display = [
          //     message
          //   ];
          //   console.table(message);
          // } else {
          //   console.log(message);
          // }
          console.log(message);
          break;
        }
    }
  }
}

let $ = jQuery;

// Initiate LocomotiveScroll
const scroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true
});

class NavTrigger {
  constructor(view) {
    this.view = view;
    self = this;
    this.view.addEventListener('click', evt => this.triggerNav(evt), false);
  }
  triggerNav(evt) {
    evt.preventDefault();
    self.view.classList.toggle('is-active');
    document.getElementsByClassName('nav-trigger')[0].classList.toggle('is-active');
    document.body.classList.toggle('nav-is-open');
  }
}

class SelectColorSwitcher {
  constructor(view) {
    this.view = view;
    this.view.addEventListener('change', evt => this.onChange(evt), false);
    this.onChange(null);
  }
  onChange(evt) {
    if(this.view.value != "") {
      this.view.classList.add('option-selected');
    } else {
      this.view.classList.remove('option-selected');
    }
  }
}

class JumpLink {
  constructor(view,target = null) {
    this.view = view;
    let myLink = view.getAttribute("href").replace("#","").replace("/","");
    debug(myLink);
    for(let anchor of document.getElementsByTagName("a")) {
      if(anchor.getAttribute('name') == myLink) {
        this.target = anchor;
      }
    }
    this.view.addEventListener('click', evt => this.jumpToLink(evt), false);
  }
  jumpToLink(evt,linkTarget) {
    evt.preventDefault();
    if(this.target) {
      if(this.target.getAttribute("name") == 'top') {
        scroll.scrollTo('top',{
        	'offset': 0,
        	'easing': [0.25, 0.00, 0.35, 1.00],
        	'disableLerp': true
        });
        // 'callback': function() {
        //   //scrollto callback
        // },
        // 'duration': 600,
      } else {
        scroll.scrollTo(this.target,{
          'offset': -200,
          'callback': function() {
            //scrollto callback
          },
          'duration': 600,
          'easing': [0.25, 0.00, 0.35, 1.00],
          'disableLerp': true
        });
      }
      // scroll.scrollTo(this.target);
    }
  }
}
class Overlay {
  constructor(view) {
    this.view = view;
  }
}
class MobileNavLink {
  constructor(view) {
    this.view = view;
    this.view.addEventListener('click', evt => this.openSubMenu(evt), false);
  }
  openSubMenu(evt) {
    evt.preventDefault();
    for (var navItem of document.getElementsByClassName('nav-item')) {
      if (navItem != this.view.parentNode) {
        navItem.classList.remove('selected');
      }
    }
    this.view.parentNode.classList.toggle('selected');
  }
}
class ShowHideContainer {
  constructor(view) {
    this.view = view;
    let trigger = this.view.getElementsByClassName('show-hide-trigger')[0];
    trigger.addEventListener('click', evt => this.toggleShow(evt), false);
  }
  toggleShow(evt) {
    evt.preventDefault();
    this.view.classList.toggle('open');
    return false;
  }
}
class BackgroundVideo {
  constructor(view) {
    this.view = view;
    let _video_opts = {
      mp4: $(this.view).data('mp4'),
      webm: $(this.view).data('webm'),
      poster: $(this.view).data('poster'),
    }
    let video_obj = new vidbg('.vidbg-box',_video_opts);
  }
}
class Slider {
  constructor(view,autoplay=true,fade=true,autplaySpeed=5500,speed=2000,useArrows=true,useDots=false,sliderType='slider',slidesToShow=5) {
    this.view = view;
    if(this.view.getAttribute('data-fade')) {
      let fadeString = this.view.getAttribute('data-fade');
      this.fade = (fadeString == "true");
    }
    if(this.view.getAttribute('data-autoplay')) {
      let autoPlayString = this.view.getAttribute('data-autoplay');
      this.autoplay = (autoPlayString == "true");
    }
    if(this.view.getAttribute('data-autoplay-speed')) {
      this.autplaySpeed = this.view.getAttribute('data-autoplay-speed');
    }
    if(this.view.getAttribute('data-speed')) {
      this.speed = this.view.getAttribute('data-speed');
    }
    if(this.view.getAttribute('data-arrows')) {
      let useArrowsString = this.view.getAttribute('data-arrows');
      this.useArrows = (useArrowsString == "true");
    }
    if(this.view.getAttribute('data-dots')) {
      let useDotsString = this.view.getAttribute('data-dots');
      this.useDots = (useDotsString == "true");
    }
    if(this.view.getAttribute('data-slider-type')) {
      this.sliderType = this.view.getAttribute('data-slider-type');
    }
    if(this.view.getAttribute('data-slides-to-show')) {
      this.slidesToShow = this.view.getAttribute('data-slides-to-show');
    }
    let _slider_opts = {
      fade: this.fade,
      autoplay: this.autoplay,
      autoplaySpeed: this.autplaySpeed,
      speed: 900,
      arrows: this.useArrows,
      dots: this.useDots,
      adaptiveHeight: false,
      pauseOnHover: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      respondTo: 'slider'
    };
    let _carousel_opts = {
      slidesToShow: this.slidesToShow,
      slidesToScroll: 5,
      autoplay: this.autoplay,
      autoplaySpeed: this.autplaySpeed,
      speed: 900,
      infinite: true,
      adaptiveHeight: false,
      arrows: this.useArrows,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      centerMode: false,
      // asNavFor: '#project-media',
      focusOnSelect: true,
      centerPadding: '1.5%',
      dots:false,
      responsive: [{
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // arrows: false
        }
      }

    ]
    }
    if(this.sliderType == 'carousel') {
      if($(this.view).data("control")) {
        _carousel_opts.asNavFor = $(this.view).data('control');
      }
      // $(this.view).slick(_carousel_opts);
    } else {
      if($(this.view).data("control")) {
        _slider_opts.asNavFor = $(this.view).data('control');
      }
      $(this.view).slick(_slider_opts);
    }
  }
  show_next_photo() {
    $(this.view).slick('slickNext');
  }
}
class QuoteSlider {
  constructor(view,autoplay=true,fade=true,autplaySpeed=5500,speed=2000,useArrows=true,useDots=false,sliderType='slider',slidesToShow=5) {
    this.view = view;
    let _slider_opts = {
      fade: false,
      autoplay: true,
      autoplaySpeed: 8000,
      speed: 900,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      pauseOnHover: false,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      respondTo: 'slider'
    };
    $(this.view).slick(_slider_opts);
  }
}
class BlogCarousel {
    constructor(view) {
      this.view=view;
      this.setupCarousel();
    }
    setupCarousel() {
      let _carousel_opts = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 900,
        infinite: true,
        adaptiveHeight: false,
        arrows: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '1.5%',
        pauseOnHover: false,
        dots:false,
        responsive: [{
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            // arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // arrows: false
          }
        }]
      }
      $(this.view).slick(_carousel_opts);
    }
}
class LogoCarousel {
    constructor(view) {
      this.view=view;
      this.setupCarousel();
    }
    setupCarousel() {
      Marquee3k.init();
    }
}
class Header {
  constructor(view) {
    this.view = view;
    //add event listener for scroll
    this.checkScroll(null);
    document.addEventListener('scroll', (evt) => {
      this.checkScroll(evt);
    });
  }
  checkScroll(evt) {
    if (document.body.scrollTop >= 125 || document.documentElement.scrollTop >= 125) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }
}
class ViewportAnimate {
  constructor(view) {
    this.view = view;
    this.view.addEventListener('isinview', () => {
      debug("element is in view");
      this.view.classList.add("in-view");
    });
  }
  checkInViewport(evt=null) {
    if(this.isInViewport()) {
      this.view.classList.add("in-view");
    }
  }
}
class Site {
  constructor() {
    this.viewComponentClasses = {
      'NavTrigger': NavTrigger,
      'Slider': Slider,
      'BlogCarousel': BlogCarousel,
      'LogoCarousel': LogoCarousel,
      'QuoteSlider': QuoteSlider,
      'JumpLink': JumpLink,
      'MobileNavLink': MobileNavLink,
      'Header': Header,
      'Overlay': Overlay,
      'ShowHideContainer': ShowHideContainer,
      'BackgroundVideo': BackgroundVideo,
      'ViewportAnimate': ViewportAnimate,
      'SelectColorSwitcher': SelectColorSwitcher
    };
    let documentLinks = document.getElementsByTagName('a');
    for (let anchor of documentLinks) {
      if(anchor.getAttribute('href') && anchor.getAttribute('href') != "#" && (anchor.getAttribute('href').indexOf("#")) == 0) {
        let newJumpLink = new JumpLink(anchor);
      }
    }
    let colorSelects = document.querySelectorAll('select.gfield_select');
    for (let colorSelect of colorSelects) {
      let newColorSelect = new SelectColorSwitcher(colorSelect);
    }
    document.body.classList.add('loaded');
    this.setupLocomotive();
    this.instantiateViewComponents();

    scroll.update();
    setTimeout(function(){ scroll.update(); }, 500);
  }
  scrollToAnchor() {
    if(window.loction.hash) {
      debug(window.location.hash);
      for(let anchor of document.getElementsByTagName("a")) {
        if(anchor.getAttribute('name') == window.loction.hash) {
          this.target = anchor;
        }
      }
      let position = $(this.target).offset().top - 120;
      $.scrollTo(position, 250);
    }
  }
  setupLocomotive() {
    //Locomotive must be declared at the root scope level.
    scroll.on('call', (custom_event_name,view_action,evt) => {
        let el = evt.el;
        if(view_action == 'in-view') {
          let event  = new Event('inview',{ bubbles: false, cancelable: false });
          el.dispatch(event);
        }
    });
  }
  instantiateViewComponents() {
    let domComponents = document.querySelectorAll('[data-script]');
    // loop through each of the components that has a data-script attribute
    for (let element of domComponents) {
      let viewComponentName = element.getAttribute('data-script');
      // instantiate the class and pass thew dom element
      try {
        new this.viewComponentClasses[viewComponentName](element, this.config);
      } catch (err) {
        debug(`could not instantiate: ${viewComponentName}. Class doesn't exist`);
        debug(err);
        debug(element);
      }
    }
  }
}
// Run the initialization function on DOM ready

document.addEventListener("DOMContentLoaded", (event) => {
  let site = new Site();
});
